import api from "./http";

export const ApiAbsensi = {
    get :(uuid_kamar:string)=>{
        return api.get(`/perizinan/absensi/${uuid_kamar}`)
    },
    post:(data:{uuid_kamar:string,santri:string[]})=>{
        return api.post(`/perizinan/absensi`,data)
    }
}